import { config } from "@/config";

interface IAnalyticsEventConfig {
  title: string;
  excludeFromFirestore?: boolean;
  anonymous?: boolean;
  disabled?: boolean;
}

export const ANALYTICS_EVENTS: Record<string, IAnalyticsEventConfig> = {
  click: {
    title: "Click",
    excludeFromFirestore: true,
  },
  invalid_email: {
    title: "Invalid Email",
  },
  login_attempt: {
    title: "Login Attempt",
  },
  login: {
    title: "Login",
  },
  logout: {
    title: "Logout",
  },
  user_name_update: {
    title: "User Name Update",
  },
  register: {
    title: "Register",
    anonymous: true,
  },
  error: {
    title: "Error",
    anonymous: true,
  },
  filter_advizers: {
    title: "Filter Advizers",
  },
  no_advizers_found: {
    title: "No Advizers Found",
  },
  video_start: {
    title: "Video Start",
    disabled: config.isPartnerApp,
  },
  video_progress: {
    title: "Video Progress",
    disabled: config.isPartnerApp,
  },
  video_progress_every_5_seconds: {
    title: "Video Progress Every 5 Seconds",
    disabled: config.isPartnerApp,
  },
  video_pause: {
    title: "Video Pause",
    disabled: config.isPartnerApp,
  },
  video_stop: {
    title: "Video Stop",
    disabled: config.isPartnerApp,
  },
  video_seek: {
    title: "Video Seek",
    disabled: config.isPartnerApp,
  },
  video_end: {
    title: "Video End",
    disabled: config.isPartnerApp,
  },
  accept_cookies: {
    title: "Accept Cookies",
  },
  reject_cookies: {
    title: "Reject Cookies",
    anonymous: true,
  },
  video_error: {
    title: "Video Error",
    anonymous: true,
    disabled: config.isPartnerApp,
  },
  page_404: {
    title: "404 Page Not Found",
    anonymous: true,
  },
  update_user_profile: {
    title: "Update User Profile",
  },
  filter_playlists: {
    title: "Filter Playlists",
  },
  playlist_start: {
    title: "Playlist Start",
    disabled: config.isPartnerApp,
  },
  playlist_complete: {
    title: "Playlist Complete",
    disabled: config.isPartnerApp,
  },
  get_recommended_playlists: {
    title: "Get Recommended Playlists",
    disabled: config.isPartnerApp,
  },
  playlist_scale_select: {
    title: "Playlist Scale Select",
    disabled: config.isPartnerApp,
  },
  playlist_error: {
    title: "Playlist Error",
  },
  assignment_create: {
    title: "Assignment Create",
  },
  assignment_update_type: {
    title: "Assignment Update Type",
  },
  assignment_add_playlist: {
    title: "Assignment Add Playlist",
  },
  assignment_remove_playlist: {
    title: "Assignment Remove Playlist",
  },
  assignment_update_title: {
    title: "Assignment Update Title",
  },
  assignment_update_instructions: {
    title: "Assignment Update Instructions",
  },
  assignment_update_count: {
    title: "Assignment Update Count",
  },
  assignment_update_total_minutes_to_complete: {
    title: "Assignment Update Total Minutes To Complete",
  },
  assignment_add_student: {
    title: "Assignment Add Student",
  },
  assignment_user_consent_accept: {
    title: "Assignment User Consent Accept",
  },
  assignment_user_consent_reject: {
    title: "Assignment User Consent Reject",
  },
  assignment_add_prompt: {
    title: "Assignment Add Prompt",
  },
  assignment_remove_prompt: {
    title: "Assignment Remove Prompt",
  },
  assignment_open_student_view: {
    title: "Assignment Open Student View",
  },
  assignment_copy_link: {
    title: "Assignment Copy Link",
  },
  assignment_copy_email_template: {
    title: "Assignment Copy Email Template",
  },
  assignment_open_results_view: {
    title: "Assignment Open Results View",
  },
  assignment_update_student_response: {
    title: "Assignment Update Student Response",
  },
  assignment_export_student: {
    title: "Assignment Export Student",
  },
  ad_link_click: {
    title: "Ad Link Click",
  },
  get_recs_from_pdf: {
    title: "Get Recs From PDF",
  },
  retry_recs_from_pdf: {
    title: "Retry Recs From PDF",
  },
  visit_advizer_video_directly: {
    title: "Visit Advizer Video Directly",
  },
  assignment_export_all: {
    title: "Assignment Export All",
  },
  assignment_export_canvas: {
    title: "Assignment Export Canvas",
  },
  feedback: {
    title: "Feedback",
    disabled: config.isPartnerApp,
  },
  get_recommended_advizers: {
    title: "Get Recommended Advizers",
  },
  advizer_recommendations_error: {
    title: "Advizer Recommendations Error",
  },
  video_reaction: {
    title: "Video Reaction",
    disabled: config.isPartnerApp,
  },
  level_up: {
    title: "Level Up",
  },

  // playlist_step_start: {
  //   title: "Playlist Step Start",
  // },
};
